import { Adapter as o } from "../../../adapter.js";
import { FacebookAnalyticsModel as a } from "./facebook.model.js";
class d extends o {
  adapt(e) {
    return new a({
      pixelId: e.pixel_id
    });
  }
  serialize(e) {
  }
}
export {
  d as FacebookAnalyticsAdapter
};
//# sourceMappingURL=facebook.adapter.js.map
